export default __webpack_public_path__ + "static/media/Fil.911c6dcd.svg";